import { render } from "./PagesEditGallery.vue?vue&type=template&id=20ad395c&scoped=true"
import script from "./PagesEditGallery.vue?vue&type=script&lang=js"
export * from "./PagesEditGallery.vue?vue&type=script&lang=js"

import "./PagesEditGallery.vue?vue&type=style&index=0&id=20ad395c&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ad395c"]])

export default __exports__